import { API_AUTH } from "./common";

const StoreApi = {
  phanQuyenCamDo: () => API_AUTH.get(`quan-ly-cho-vay/phan-quyen-cam-do`, {}),
  phanQuyenTinChap: () =>
    API_AUTH.get(`quan-ly-cho-vay/phan-quyen-tin-chap`, {}),
  phanQuyenNoPhaiThu: () =>
    API_AUTH.get(`quan-ly-cho-vay/phan-quyen-no-phai-thu`, {}),
  phanQuyenTraGop: () => API_AUTH.get(`quan-ly-cho-vay/phan-quyen-tra-gop`, {}),
  phanQuyenQuanLyCuaHang: () =>
    API_AUTH.get(`quan-ly-cua-hang/phan-quyen-cua-hang`, {}),
  phanQuyenHopDongBiXoa: () =>
    API_AUTH.get(`phan-quyen-danh-sach-hop-dong-bi-xoa`, {}),
  phanQuyenPhieuThuBiXoa: () =>
    API_AUTH.get(`phan-quyen-danh-sach-phieu-thu-bi-xoa`, {}),
  phanQuyenPhieuChiBiXoa: () =>
    API_AUTH.get(`phan-quyen-danh-sach-phieu-chi-bi-xoa`, {}),
  phanQuyenDanhSachTaiSan: () =>
    API_AUTH.get(`quan-ly-tai-san/phan-quyen-tai-san`, {}),
  phanQuyenKiemTraNoXau: () =>
    API_AUTH.get(`quan-ly-khach-hang/phan-quyen-kiem-tra-no-xau-rui-ro`, {}),
  phanQuyenCheckThongTinKh: () =>
    API_AUTH.get(
      `quan-ly-khach-hang/phan-quyen-kiem-tra-thong-tin-khach-hang`,
      {}
    ),
  phanQuyenCongNoThanhLy: () =>
    API_AUTH.get(`quan-ly-tai-san/phan-quyen-cong-no-thanh-ly`, {}),
  phanQuyenDanhSachKho: () => API_AUTH.get(`quan-ly-kho/phan-quyen-kho`, {}),
  phanQuyenHopDongChoDuyet: () =>
    API_AUTH.get(`bao-cao/phan-quyen-hop-dong-cho-duyet`, {}),
  phanQuyenDanhSachKhachHang: () =>
    API_AUTH.get(`quanlykhachhang/phan-quyen-danh-sach-khach-hang`, {}),
  phanQuyenDuNoChoVay: () =>
    API_AUTH.get(`bao-cao/phan-quyen-du-no-cho-vay`, {}),
  phanQuyenDuNoNhanVay: () =>
    API_AUTH.get(`bao-cao/phan-quyen-du-no-nhan-vay`, {}),
  phanQuyenDuNoGiaoNhanVien: () =>
    API_AUTH.get(`bao-cao/phan-quyen-du-no-giao-nhan-vien`, {}),
  phanQuyenNhanVay: () =>
    API_AUTH.get(`quan-ly-nhan-vay/phan-quyen-nhan-vay`, {}),
  phanQuyenDongTienNhanh: () =>
    API_AUTH.get(`DongTienNhanh/GetPhanQuyen`, {}),
  phanQuyenThuChiHopDong: () =>
    API_AUTH.get(`thu-chi-hop-dong/phan-quyen-thu-chi-hop-dong`, {}),
  phanQuyenThuChiNgoaiLe: () =>
    API_AUTH.get(`thu-chi-hop-dong/phan-quyen-thu-chi-ngoai-le`, {}),
  phanQuyenNguonVon: () => API_AUTH.get(`nguon-von/phan-quyen-nguon-von`, {}),

  phanQuyenQuyTrinhPheDuyet: () => API_AUTH.get(`bao-cao/QuyenQuyTrinhPheDuyet`, {}),
  phanQuyenTaiKhoanIcloud: () => API_AUTH.get(`taikhoanicloud/QuyenTaiKhoanIcloud`, {}),
    getAllQuyen: () => {
    return API_AUTH.get(`phanquyen/GetAllQuyen`, {});
  },
    phanQuyenGoiVay: () => API_AUTH.get(`danhsachgoivay/phanquyen`, {}),
};

export default StoreApi;
